import type {ReactAction} from '@netx/core/bootstrap';
import {faLink} from '@fortawesome/pro-solid-svg-icons';
import {canCreateShareLinkFromSavedCart} from '../enablers';
import {CART_SAVED_ACTION_LABELS} from '../locales';
import {type ISavedCart} from '../schema';
import {CART_SAVED_EVENT} from './constants';

export const cartSavedActionShareLinkIcon = faLink;

/**
 * Saved cart share link
 * @param params
 * @returns Action
 */
export const cartSavedActionShareLink = (
	savedCart?: ISavedCart,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'saved-cart-share-link',
	cb: () => dispatcher.trigger(CART_SAVED_EVENT.SHARE_LINK, savedCart),
	enableTest: () => canCreateShareLinkFromSavedCart(savedCart),
	icon: cartSavedActionShareLinkIcon,
	get label() {
		return CART_SAVED_ACTION_LABELS.SHARE_LINK;
	},
	...params,
});

export default cartSavedActionShareLink;
